module.exports = __webpack_public_path__ + "static/media/veryvell_lemon.e6e92bb1.png";